<div class="w-full">
  <div class="relative flex items-center w-full">
    <input
      type="text"
      class="block w-full rounded-md border-gray-300 pr-12 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
      (ngModelChange)="query.next($event)"
      [ngModel]="query | async"
      [placeholder]="{ key: 'search' } | i18n"
      />

    @if (query | async) {
      <div
        class="absolute inset-y-0 right-0 flex py-1.5 pr-1.5 items-center"
        >
        <button class="flex items-center" (click)="reset()">
          <ng-icon name="heroXCircle" size="20px" class="text-gray-400"></ng-icon>
        </button>
      </div>
    }
  </div>
</div>
